const comm = {
    rebless_clinic: "rebless™ Clinic",
    rebless_clinic_is: "rebless™ Clinic is"
};

export default comm;